<template>
  <div class="audience">
    <ul class="audience__header">
      <li class="audience__title">
        {{chartTitle}}
      </li>
      <li class="audience__tools">
        <el-button type="text" class="audience__tools-button" :disabled="saveChart" @click="onSave">
          <i class="material-icons color_grey">save</i>
        </el-button>
        <el-button type="text" class="audience__tools-button" v-if="!isEdit" @click="editChart">
          <i class="material-icons color_grey">edit</i>
        </el-button>
      </li>
    </ul>

    <el-card shadow="hover" class="audience__card" v-loading="pending">
      <audience-header :chart-name="name" />

      <audience-body
        :data="data"
        :chart-name="name"
        :save-chart="saveChart"
        :title="chartTitle"
        @onSavedChart="handleSaved"
        @onSaveChart="handleSave"
      />
    </el-card>

  </div>
</template>

<script>
  // mixins
  import { audit } from "../../../../../../../mixins/audit";

  // components
  import AudienceHeader from "./header/AudienceHeader";
  import AudienceBody from "./body/AudienceBody";

  export default {
    name: "Audience",
    data() {
      return {
        name: "ReachAudience",
        saveChart: false,
        chartTitle: this.$t('feed.audit.audience.title'),
      };
    },
    components: {
      AudienceHeader,
      AudienceBody
    },
    mixins: [
      audit
    ],
  }
</script>

<style>
  .audience__header {
    display: flex;
    justify-content: space-between;
    align-items: start;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .audience__title {
    margin-bottom: 20px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #5E6D82;
  }

  .audience__tools .material-icons {
    font-size: 16px;
  }

  .audience__tools {
    margin-top: 4px;
    margin-right: 15px;
  }

  .audience__tools-button {
    padding: 0;
    color: #5e6d82;
  }

  .audience__tools-button:hover {
    color: #B3BCCC;
    font-size: 12px;
  }

  .audience__card {
    margin-bottom: 20px;
  }

  .hidden-chart-name {
    display: none;
    padding: 20px 10px;
    font-size: 16px;
  }
  .hidden-chart-name--visible {
    display: flex;
    justify-content: space-between;
  }
  .clone--hide {
    position: absolute;
  }
</style>
